<script>

    import Moment from 'moment'
    import { toast } from 'bulma-toast'
    import { accountStore, accountsStore, modalStore, adminStore } from '../stores'

    import { isPermission } from '../$methods/permissions.methods'

    import AccountsService from '../$services/accounts.service'
    import DateMethods from '../$methods/date.methods'
    import NumeralMethod from '../$methods/numeral.methods'
    import TranslateMethods from '../$methods/translate.methods'

    import Button from '../$components/button.svelte'
    import ButtonDelete from '../$components/button.delete.svelte'
    import ButtonModal from '../$components/button.modal.svelte'
    import InfoCard from '../$components/info.card.svelte'
    import InfoField from '../$components/info.field.svelte'

    export let all = false

    let loading = false
    let data = {}
    let element = null

    getAccountDetails()

    async function getAccountDetails() {

        data = {}

        loading = true
        const resp = await AccountsService.getAccountDetails($accountStore._id)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        data = resp.data
    }

    async function deleteAccount() {

        loading = true
        const resp = await AccountsService.deleteAccount($accountStore._id)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        accountsStore.remove($accountStore._id)
        toast({message: 'Cuenta borrada', type: 'is-success'})

        modalStore.set('user_modal')
    }

    async function getShipmentsReport() {

        loading = true
        const blob = await AccountsService.getShipmentsReport($accountStore._id)
        loading = false

        if(!blob)
            return toast({message: 'Error al descargar el reporte', type: 'is-danger'})

        let fileName = `${ $accountStore.user.email }.cuenta.envios.${ Moment($accountStore.expired).format('DD-MM-YYYY') }`

        element.download = `${fileName}.xlsx`
        element.href = window.URL.createObjectURL(blob)
        element.click()
    }

</script>

<a bind:this={element} href="/" style="display: none;">.</a>

{#if !loading}

    <InfoCard subtitle="Cuenta">
        <div class="columns is-multiline is-mobile is-variable is-4 mb-0">
            <InfoField label="Estatus" icon="fas fa-info-circle" value={ TranslateMethods.get($accountStore.status) } />
            <InfoField label="Límite" icon="fas fa-dollar-sign" value={ $accountStore.limit ? NumeralMethod.cash($accountStore.limit) : 'Sin límite' } />
            {#if all && $accountStore.user}
                <InfoField label="Usuario" icon="fas fa-user" value={ $accountStore.user.name } bold />
                <InfoField label="Correo" icon="fas fa-envelope" value={ $accountStore.user.email } />
            {/if}
            {#if $accountStore.admin}
                <InfoField label="Administrador" icon="fas fa-user-shield" value={ $accountStore.admin.name } />
                <InfoField label="Correo admin" icon="fas fa-envelope" value={ $accountStore.admin.email } />
            {/if}
            <InfoField label="Activación" icon="far fa-calendar-alt" value={ DateMethods.dateTimeLarge($accountStore.activated) } />
            <InfoField label="Corte" icon="far fa-calendar-times" value={ DateMethods.dateTimeLarge($accountStore.expired) } />
            {#if $accountStore.status === 'paid'}
                <InfoField label="Fecha de pago" icon="far fa-calendar-check" value={ DateMethods.dateTimeLarge($accountStore.payment) } />
            {/if}
            {#if $accountStore.reference}
                <InfoField label="Referencia" icon="fas fa-hashtag" value={ $accountStore.reference } />
            {/if}
        </div>
    </InfoCard>

    <InfoCard subtitle="Resumen">
        <div class="columns is-multiline is-mobile is-variable is-4 mb-0">
            <InfoField label="Envíos realizados" icon="fas fa-shipping-fast" value={ $accountStore.shipments.length } />
            <InfoField label="Total envíos" icon="fas fa-dollar-sign" value={ NumeralMethod.cash(data.shipments) } />
            <InfoField label="Total pendiente" icon="fas fa-clock" value={ NumeralMethod.cash(data.pendingAmount) } />
            <InfoField label="Total al corte" icon="fas fa-calculator" value={ NumeralMethod.cash(data.shipments) } bold />
        </div>
    </InfoCard>

    {#if $accountStore.prepayments?.length}
        <InfoCard subtitle="Pagos anticipados">
            <div class="columns is-multiline is-mobile is-variable is-4 mb-0">
                {#each $accountStore.prepayments as prepayment}
                    <div class="column is-half pb-3">
                        <p class="is-size-6 has-text-weight-bold">{ NumeralMethod.cash(prepayment.amount) }</p>
                        <p class="is-size-7 has-text-grey">{ prepayment.reference }</p>
                        <p class="is-size-7 has-text-grey">{ DateMethods.dateTimeLarge(prepayment.payment) }</p>
                    </div>
                {/each}
            </div>
        </InfoCard>
    {/if}

    <div class="items-end">
        <div class="buttons">
            {#if isPermission($adminStore, 'UsersView.Account.Delete')}
                <ButtonDelete on:confirm={deleteAccount} { loading } />
            {/if}
            {#if isPermission($adminStore, 'UsersView.Account.ReportShipments')}
                <Button on:click={getShipmentsReport} icon="file-excel" text="Reporte envíos" />
            {/if}
            {#if isPermission($adminStore, 'UsersView.Account.Update')}
                <ButtonModal modalId="account_update_modal" icon="edit" text="Actualizar" />
            {/if}
        </div>
    </div>
{/if}
